/**
 * @see public.locales
 */
// Topic nodes
export const UI_PREFIX = 'constants.ui';
export const CARDS_PREFIX = 'cards';
export const FAQ_CARD_PREFIX = `${CARDS_PREFIX}.faq`;
export const HEADER_PREFIX = `${CARDS_PREFIX}.header`;
export const ORDER_INFO_PREFIX = `${CARDS_PREFIX}.orderInfo`;
export const ETA_PREFIX = `${CARDS_PREFIX}.eta`;
export const FAQ_QUESTIONS_PREFIX = 'faqItems';

// Values
export const ETA_MINUTES = `${ETA_PREFIX}.ETA_MINUTES`;
export const FAQ_CARD_NEED_HELP = `${FAQ_CARD_PREFIX}.FAQ_CARD_NEED_HELP`;
export const HEADER_DELIVERY_DETAILS = `${HEADER_PREFIX}.DELIVERY_DETAILS`;
export const ORDER_INFO_ORDER_NUMBER = `${ORDER_INFO_PREFIX}.ORDER_NUMBER`;
export const THANKS_FOR_USING_GRAB = `${ORDER_INFO_PREFIX}.THANKS_FOR_USING_GRAB`;
export const SCHEDULED = `${ORDER_INFO_PREFIX}.SCHEDULED`;
export const UI_TOGGLE_SHOW_MORE = `${UI_PREFIX}.TOGGLE_SHOW_MORE`;
export const UI_TOGGLE_SHOW_LESS = `${UI_PREFIX}.TOGGLE_SHOW_LESS`;

// FAQ key list
export const FAQ_ITEMS_LIST = [
  'whatIsLink',
  'deliveryNotScheduled',
  'deliveryStuck',
  'deliveryReverse',
  'deliveryTime',
  'deliveryNotAssigned',
  'deliveryNewDriver',
  'contactDriver',
];

// Download App
export const DOWNLOAD_APP_PREFIX = `${CARDS_PREFIX}.download_app`;
export const DOWNLOAD_APP_TITLE = `${DOWNLOAD_APP_PREFIX}.title`;
export const DOWNLOAD_APP_CONTENT = `${DOWNLOAD_APP_PREFIX}.content`;
export const DOWNLOAD_APP_BUTTON = `${DOWNLOAD_APP_PREFIX}.button`;
